import { createQueryKeys } from '@lukemorales/query-key-factory'

import {
  type StoplightIndicator,
  createLibraryIndicator,
  deleteLibraryIndicator,
  getLibraryFilterOptions,
  getListLibraryIndicators,
  updateLibraryIndicator,
} from '~/api'
import { type PlatformLanguage } from '~/utils/types/i18n'

export const indicatorsQueries = createQueryKeys('indicators', {
  getLibraryFilterOptions: (language: PlatformLanguage) => ({
    queryKey: [language],
    queryFn: getLibraryFilterOptions,
  }),
  getListLibraryIndicators: (filters: Record<string, unknown>) => ({
    queryKey: ['indicators', 'library', filters],
    queryFn: async ({ pageParam = 0 }) => {
      const response = await getListLibraryIndicators({
        ...filters,
        page: pageParam,
      })
      return response.data.data.listStoplightIndicatorsBy
    },
  }),

  createLibraryIndicator: (indicator: Partial<StoplightIndicator>) => ({
    queryKey: [{ indicator }],
    queryFn: async () => await createLibraryIndicator(indicator),
  }),

  updateLibraryIndicator: (
    indicator: Partial<StoplightIndicator>,
    stoplightId: number | null,
  ) => ({
    queryKey: [{ indicator, stoplightId }],
    queryFn: async () => await updateLibraryIndicator(indicator, stoplightId),
  }),

  deleteLibraryIndicator: (id: number) => ({
    queryKey: [{ id }],
    queryFn: async () => await deleteLibraryIndicator(id),
  }),
})
